import styled from "styled-components";

import { CheckboxLabel } from "@similarweb/ui-components";

export const StyledCheckboxContainer = styled.div`
    margin-left: 16px;
    margin-right: 16px;

    & ${CheckboxLabel} {
        font-size: 16px;
    }
`;
